import PetsIcon from '@/assets/img/pets.png';
import { ReactComponent as CloseIcon } from '@/assets/img/close-icon-new-v2.svg';
import './SelectedManagers.scss';
import InitialsAvatar from 'react-initials-avatar';
import 'react-initials-avatar/lib/ReactInitialsAvatar.css';

export type SelectedServiceProvidersProps = {
  selectedServiceProviders?: any[];
  removeProvider: (sp: any) => void;
  isShowPhone?: boolean;
  showDeleteOption?: boolean;
  showInstName?: boolean;
};

export const SelectedManagers = ({
  selectedServiceProviders,
  removeProvider,
  isShowPhone = false,
  showDeleteOption = true,
  showInstName = false,
}: SelectedServiceProvidersProps) => {
  return (
    <div className="flex gap-1 selected-providers">
      {selectedServiceProviders?.map((serviceProvider: any) => (
        <span className="profile-hg rounded-full">
          <InitialsAvatar name={serviceProvider.name} className={`avatar padding ${serviceProvider?.isKeyPerson ? 'show-primary' : ''}`} />
          {showDeleteOption && <span className="rounded-full overlay flex justify-center items-center">
            <CloseIcon onClick={() => removeProvider(serviceProvider)} />
          </span>}
          <div className="provider-details">
            <div>
              <p>{serviceProvider.name} {isShowPhone && <span>{`(${serviceProvider?.phone})`}</span>}</p>
              <p>{serviceProvider.email}</p>
              <p>{showInstName ? `${serviceProvider?.institute?.name ? `${serviceProvider?.institute?.name} - ` : ''}` : ''}{serviceProvider?.designation}</p>
            </div>
          </div>
        </span>
      ))}
    </div>
  );
};

SelectedManagers.displayName = 'SelectedManagers';
